import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { currentUser } from 'redux/session/selectors';
import { getFullAddress } from 'utilities/helper.util';
import { SkeletonText, Button } from 'carbon-components-react';
import { Add16, ArrowRight16 } from '@carbon/icons-react';
import {
  LocalStoreContext,
  LocalDispatchContext
} from '../../localStore/context';
import { setMultipleDrawMode } from '../../localStore/actions';

const ConfirmationPanel: React.FC<Props> = ({
  cancelEnquiryHandler,
  confirmDraw,
  showShapeOutTeamWarning
}) => {
  const user = useSelector(currentUser);
  const localStore = useContext(LocalStoreContext);
  const localDispatch = useContext(LocalDispatchContext);
  const { shapes } = localStore;
  return (
    <div className="draw-confirmation-modal">
      <div className="draw-confirmation-panel">
        <div className="address-container">
          <div className="address-heading">
            Approximate address (this can be refined later)
          </div>
          {shapes.length > 0 && shapes[0].address ? (
            <div className="address-body">
              {shapes.length === 1
                ? getFullAddress(shapes[0].address)
                : 'Multiple addresses'}
            </div>
          ) : (
            <SkeletonText />
          )}
        </div>
        {showShapeOutTeamWarning && (
          <div className="warning-container">
            {shapes.length > 1 ? 'Some shape(s) are' : 'This shape is'} outside
            of the team boundary. Continue anyway?
          </div>
        )}
        <div className="button-container">
          <div className="sub-buttons">
            {!user?.appFeatures?.includes('DISABLED_LARGE_SCALE_ENQUIRIES') && (
              <Button
                kind="tertiary"
                renderIcon={Add16}
                onClick={() => localDispatch(setMultipleDrawMode(true))}
              >
                Add areas
              </Button>
            )}
            <Button kind="tertiary" onClick={() => cancelEnquiryHandler(false)}>
              Redraw
            </Button>
          </div>
          <Button
            kind="secondary"
            renderIcon={ArrowRight16}
            onClick={() => confirmDraw()}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

type Props = {
  cancelEnquiryHandler: Function;
  confirmDraw: Function;
  showShapeOutTeamWarning: boolean;
};

export default React.memo(ConfirmationPanel);
